import React from "react";
import { Link } from "react-router-dom";
import { LIGHT_LOGO_URL as logo, COMP_INFO } from "../../config/siteConfig";
import { BRAND_NAME } from "../../constants/brand";
import FlightRoutesBackground from "./FlightRoutesBackground";

const FEATURES = [
  { icon: "bi-airplane", text: "Publish flight inventory and fares" },
  { icon: "bi-file-earmark-arrow-up", text: "Bulk upload inventory from CSV" },
  { icon: "bi-wallet2", text: "Track wallet, ledger and payouts" },
];

// Left half of the auth card (Login, Forgot Password). Hidden on mobile by the caller.
// Styles: "Auth brand panel" block in App.css.
const AuthBrandPanel = ({ ctaText, ctaLabel, ctaTo }) => (
  <div className="auth_left auth-brand">
    <FlightRoutesBackground variant="panel" />
    <Link to="/" className="auth-brand-mark" aria-label={`${BRAND_NAME} home`}>
      <img src={logo} alt="" />
      <span>
        <span className="auth-brand-name">{BRAND_NAME}</span>
        <span className="auth-brand-product">{COMP_INFO.NAME}</span>
      </span>
    </Link>

    <div className="auth-brand-body">
      <h2>Manage your inventory, fares and bookings in one place.</h2>
      <ul>
        {FEATURES.map((f) => (
          <li key={f.text}>
            <span className="auth-brand-icon"><i className={`bi ${f.icon}`} aria-hidden="true"></i></span>
            {f.text}
          </li>
        ))}
      </ul>
    </div>

    <div className="auth-brand-cta">
      <span>{ctaText}</span>
      <Link to={ctaTo}>
        {ctaLabel} <i className="bi bi-arrow-right" aria-hidden="true"></i>
      </Link>
    </div>
  </div>
);

export default AuthBrandPanel;
